import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {Navigate, Route, Routes, useParams} from "react-router-dom";
import {AdminCoursesList} from "./AdminCoursesList/AdminCoursesList";
import {AdminCourseLandingPage} from "./AdminCourseLandingPage/AdminCourseLandingPage";
import {AdminLessonLandingPage} from "@/app2/pages/ManagerView/Pages/Lessons/AdminLessonLandingPage";
import {AdminLessonPage} from "@/app2/pages/ManagerView/Pages/Lessons/AdminLessonPage";
import {AdminQuizPage} from "@/app2/pages/ManagerView/Pages/Quizzes/AdminQuizPage";
import {AdminCourseEditor} from "./AdminCourseEditor";

const useStyles = makeStyles()((theme) => ({
	adminCoursesPage: {

	}
}));

/** Old Strapi editor used `/courses/:id/edit`; app2 uses `edit-new` (improve-api). */
const CourseEditLegacyRedirect: FC = () => {
	const {id} = useParams<{id: string}>();
	return <Navigate to={`/admin/courses/${id}/edit-new`} replace />;
};

export const AdminCoursesPage: FC = () => {
	const {classes} = useStyles();

	return (
		<Box className={classes.adminCoursesPage}>
			<Routes>				<Route index element={<AdminCoursesList />}/>

				
				{/* Course editor (improve-api + React Query) */}
				<Route path="create-new" element={<AdminCourseEditor />} />
				<Route path=":id/edit-new" element={<AdminCourseEditor />} />
				<Route path=":id/edit" element={<CourseEditLegacyRedirect />} />

				{/* Course landing page and sub-routes */}
				<Route path=":id/*" element={<AdminCourseLandingPage />} />
				<Route path=":id/lessons/:lessonId" element={<AdminLessonLandingPage />} />
				<Route path=":id/lessons/:lessonId/edit" element={<AdminLessonPage />} />
				<Route path=":id/lessons/:lessonId/edit-new" element={<AdminLessonPage />} />
				<Route path=":id/quizzes/:quizId" element={<AdminQuizPage />} />
				<Route path=":id/quizzes/:quizId/edit" element={<AdminQuizPage />} />
			</Routes>
		</Box>
	);
}